var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"entreprise-container"},[_c('EntrepriseNavBar',{attrs:{"entreprise-id":_vm.entrepriseId}}),_c('div',{staticClass:"entreprise-content"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }